import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-virtual-interview',
  templateUrl: './virtual-interview.component.html',
  styleUrls: ['./virtual-interview.component.css'],
})
export class VirtualInterviewComponent {
  accessToken = localStorage.getItem('accessToken');

  constructor(private router: Router) {}

  services = [
    {
      color: 'blue',
      img: '../../../assets/icon/paper.png',
      title: 'vi.services.autoApply.title',
      description: 'vi.services.autoApply.description',
    },
    {
      color: 'pink',
      img: '/../../assets/icon/contact.svg',
      title: 'vi.services.saveHours.title',
      description: 'vi.services.saveHours.description',
    },
    {
      color: 'blue',
      img: '../../../assets/icon/lamp.png',
      title: 'vi.services.moreInterviews.title',
      description: 'vi.services.moreInterviews.description',
    },
    {
      color: 'pink',
      img: '../../../assets/icon/share.png',
      title: 'vi.services.neverMiss.title',
      description: 'vi.services.neverMiss.description',
    },
    {
      color: 'blue',
      img: '../../../assets/icon/privicy.png',
      title: 'vi.services.applyConfidence.title',
      description: 'vi.services.applyConfidence.description',
    },
  ];

  goToVirtualSteps() {
    if (!this.accessToken) {
      localStorage.setItem('redirectUrl', '/virtual-interview');
      this.router.navigate(['/login']);
    } else {
      this.router.navigate(['/virtualInterviewSteps']);
    }
  }
}